//$('#widget').draggable();

function stripHTML(dirtyString) {
    var container = document.createElement('div');
    container.innerHTML = dirtyString;
    return container.textContent || container.innerText;
}

function getHash() {
	var ratio = 1;
	var _hash = window.location.hash;
	if(_hash.length === 0){
		_hash = window.location.search;
	}
	_hash = _hash.substring(1);
	var arr = _hash.split("&");
	try{ _hash.split("&"); }catch(e){};
	try{arr[0] = new Array(arr[0].split("="));}catch(e){};
	try{arr[1] = new Array(arr[1].split("="));}catch(e){};
	var ln = arr.length;
	for(var i = 0; i < ln; i++){
		if(arr[i][0][0] === "W"){
			ratio = parseInt(arr[i][0][1])/800;
		}
	}
	var cssObj = {
		'zoom':ratio,
		'-moz-transform': 'scale('+ratio+')',
		'-moz-transform-origin' : '0 0',
		'-o-transform': 'scale('+ratio+ ', '+ratio+')',
		'-o-transform-origin': '0 0'
	};
	$("body").css(cssObj);
}


/* UTILS */

function getKeys(obj) {
    var r = []
    for (var k in obj) {
        if (!obj.hasOwnProperty(k))
            continue
        r.push(k)
    }
    return r
};

Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

var indexOf = function(arr, key) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === key) {
      return i;
    }
  }
}

function start_menu() {
  $(".start-menu").on("click",function(){
	var id = $(this).attr("id");
	$(".slide").html('');
	$(".slide").hide();
	cont = '';
	bmcont = '';

	switch (id) {
		case "kolobeh":
		slide1_anima();
		break;
		case "uprava":
		slide2_anima();
		break;
		case "listy":
		slide3_anima();
		break;
		case "kviz":
		slide4_anima();
		break;
	};
});
}

function list_menuList() {
  $(".list-menu").on("click",function(){
	var id = $(this).attr("id");
	cont = '';
	bmcont = '';

	switch (id) {
		case "list1":
		list1_anima();
		break;
		case "list2":
		list2_anima();
		break;
		case "list3":
		list3_anima();
		break;
		case "list4":
		list4_anima();
		break;
    case "list5":
		list5_anima();
		break;
    case "list6":
		list6_anima();
		break;
    case "list7":
		list7_anima();
		break;
    case "list8":
		list8_anima();
		break;
    case "list9":
		list9_anima();
		break;
    case "list10":
		list10_anima();
		break;
    case "list11":
		list11_anima();
		break;
    case "list12":
		list12_anima();
		break;
    case "list13":
		list13_anima();
		break;
	};
});
}

function kviz_menu() {
  $(".kviz-menu").on("click",function(){
	var id = $(this).attr("id");
	cont = '';
	bmcont = '';

	switch (id) {
		case "kviz1":
		kviz1_anima();
		break;
		case "kviz2":
		kviz2_anima();
		break;
		case "kviz3":
		kviz3_anima();
		break;
		case "kviz4":
		kviz4_anima();
		break;
    case "kviz5":
		kviz5_anima();
		break;
	};
});
}

function Element(id, banner, point) {
		this.id = id;
		this.banner = banner;
		this.point = point;
		this.appendPoint = function (scene) {

			$(this.point).appendTo(scene);
		}
}

function isEmpty(obj) { // credits http://stackoverflow.com/questions/4994201/is-object-empty

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var k in obj) {
        if (obj.hasOwnProperty(k)) return false;
    }

    return true;
}

function CreateElements1(data1) {

	$.each(data1, function(key, val) {


			var point = "<div class='circle_pos' id='circle_pos_"+key+"' data-clicked='"+key+"'>";
			point += "<div class='circle_leash' id='circle_leash_"+key+"'></div>";
			point += "<div class='circle_label' id='circle_label_"+key+"'>"+val.label+"</div>";
			point += "<div class='circle_bg'></div>";
			point += "<div class='circle_anim pulsateME'></div>";
			point += "<div class='circle' id='circle_"+key+"' data-clicked='"+key+"'></div>";
			point += "<div class='circle_over' id='circle_over_"+key+"' data-clicked='"+key+"'></div>";
			point += "</div>";

			var banner = val.text;

			window.elements1[key] = new Element(key, banner, point);
	});
}

function appendThisPoint(elvar, el, obj) {

	window[elvar][el].appendPoint(obj);
}

function appendThesePoints(elvar, els, obj) {

	$.each(els, function( key, val ) {
		window[elvar][val].appendPoint(obj);
	});
}

function startBox(top) {
  $( "#slide1Start" ).fadeIn( "slow", function() {
  });
  var helpBox = document.getElementById("startBox");
  TweenMax.to(helpBox, 1, {x:0, y:top,  ease:Quint.easeOut});
  TweenMax.to(helpBox, 0.5, {autoAlpha:1});
}

function returnHome(idTlac,idVrstva,idVrstva2) {
  $(idTlac).on("click", function() {
    $("#banner_box").html('');
    //$("#banner_box").removeAttr('style');
    if (idVrstva==".slide1") {
      $("#help").fadeIn(1000);
    }
    if (idVrstva2=="baner-slide-2") {
      slide2_anima();
    }
    $(idVrstva).html('');
  	$(idVrstva).fadeOut( "slow", function() { });
  });
}

function clickBanner() {
	$('.ref').on("click", function() {
		$('li.ref', $(this).parent()).removeClass('active');
		$(this).addClass('active');
		TweenMax.to('.banner', 0, {autoAlpha:0});
		TweenMax.to('.banner', 1, {x:0, y:0,  ease:Quint.easeOut});
		var id_banner = $(this).attr("id");
		var bannerBox = document.getElementById("ban_"+id_banner);
		TweenMax.to(bannerBox, 1, {x:0, y:-400,  ease:Quint.easeOut});
		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
	});
	$('.banner .banner_close').on("click", function() {
		TweenMax.to('.banner', 1, {x:0, y:0,  ease:Quint.easeOut});
		TweenMax.to('.banner', 0.5, {autoAlpha:0});
	});
}
